import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Contacto } from 'src/app/models/notificacion/contacto.model';
import { Lista } from 'src/app/pages/base/lista';
import { ContactoService } from 'src/app/services/notificacion/contacto.service';
import { XlsxService } from 'src/app/services/utils/xlsx.service';

@Component({
  selector: 'app-contacto-lista',
  templateUrl: './contacto-lista.component.html',
  styleUrls: ['./contacto-lista.component.scss']
})
export class ContactoListaComponent extends Lista implements OnInit {

    constructor(
        public router: Router,
        public messageService: MessageService,
        public service: ContactoService,
        private breadcrumbService: AppBreadcrumbService,
        private xlsxService: XlsxService

    ) {
        super(router, messageService, service, Contacto.CODIGO_MODULO, Contacto.CODIGO_REGISTRO);
        this.breadcrumbService.setItems([{ label: 'Notificacion' }, { label: 'Contactos' }]);
        this.recordName = Contacto.RECORD_NAME;
        this.name = Contacto.NOMBRE_SINGULAR;
        this.pluralName = Contacto.NOMBRE_PLURAL;
        this.navigate = [this.prefixPage, this.modulo, 'contactos'];
        this.columns = [
            { field: 'nombre_empresa', label: 'Empresa', type: 'text', hidden: !this.currentUser.superusuario },
            { field: 'id', label: 'Id', type: 'id' },
            { field: 'documento', label: 'Documento', type: 'text' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'celular', label: 'Celular', type: 'text' },
            { field: 'correo', label: 'Correo', type: 'text' },
            { field: 'activo', label: 'Activo', type: 'boolean' },
        ]
    }

    ngOnInit(): void {
    }

    
//     async importData( file: File ) {
//         try {
//             const fileReader = new FileReader();
//             fileReader.readAsArrayBuffer(file);
//             fileReader.onload = async () => {
//                 this.loading = true;
//                 let creados = 0;
//                 let actualizados = 0;
//                 this.messageService.add({severity: 'info', summary: 'Importando Contactos', detail: 'Porfavor espere...'});

//                 const lista = await this.xlsxService.toListJson(fileReader);
//                 const [ contactos ] = lista;
//                 for (const contacto of contactos) {
//                     const filtros = [
//                         { field: 'documento', type: 'unique', value: String(contacto.documento).trim() },
//                     ]
//                     const objeto = new Contacto();
//                     const contactoExistente = await this.service.getAll(Global.SIZE_GET_ALL, { filters: filtros });
//                     if ( contactoExistente.ok && contactoExistente.resp.count > 0 ) {
//                         let obj = contactoExistente.resp.rows[0];
//                         obj.correo = contacto.correo;
//                         await objeto.cargarObjeto(obj);
//                         objeto.celular = contacto.celular;
//                         objeto.documento = contacto.documento;
//                         objeto.idActualizadoPor = this.currentUser.id;
//                         objeto.serverJson = (await objeto.getFormGroup()).value;
//                         this.service.obj = objeto.serverJson;
//                         const res = await objeto.actualizar(this.service);
//                         if ( res.ok ) { actualizados += 1 };
//                     } else { 
//                         objeto.documento = String(contacto.documento);
//                         objeto.nombre = String(contacto.nombre);
//                         objeto.celular = contacto.celular;
//                         objeto.correo = contacto.correo;
//                         objeto.serverJson = (await objeto.getFormGroup()).value;                    
//                         const resp = await objeto.guardar(this.service);
//                         if ( !resp.ok ) {
//                             this.messageService.add({severity: 'error', summary: resp.resp, detail: resp.msg});
//                             return;
//                         }
//                     }
//                 }
//                 this.loading = false;
//                 this.messageService.add({severity: 'success', summary: 'Proceso Finalizado', detail: `Contactos Creados: ${ creados } - Contactos Actualizados: ${ actualizados }`});
//                 this.loadItems();
//             }
//         } catch (error: any) {
//             this.messageService.add({severity: 'error', summary: 'Error', detail: error.message});
//         }
//     }
}
